import React from "react";
import { NavLink } from "react-router-dom";
import "./Dashboard.css";     // ✅ Reuse sidebar styles
import "./ComingSoon.css";    // ✅ For coming soon message only

function ComingSoon({ title }) {
  return (
    <div className="dashboard">
      {/* Sidebar (reused from Dashboard) */}
      <aside className="sidebar">
        <div className="logo">⚡ AdminPanel</div>
        <nav>
          <ul>
            <li><NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>📊 Transactions</NavLink></li>
            <li><NavLink to="/export" className={({ isActive }) => isActive ? 'active' : ''}>📥 Exports</NavLink></li>
            <li><NavLink to="/help" className={({ isActive }) => isActive ? 'active' : ''}>📚 Help</NavLink></li>
            {/* <li><NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>⚙️ Setting</NavLink></li> */}
          </ul>
        </nav>
      </aside>

      {/* Main content */}
      <main className="main">
        <div className="coming-soon">
          <h1>{title}</h1>
          <p>🚧 This page is under construction</p>
          <p>Coming soon...</p>
        </div>
      </main>
    </div>
  );
}

export default ComingSoon;
